<template>
  <div class="aoformcheckdata">
    <svg class="aoformcheckdata__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <path d="M4.90912 4.36346H33.2728V2.18164H4.90912V4.36346ZM3.27276 36.9148V5.87666H1.09094V36.9148H3.27276ZM19.0909 34.9089C18.3774 34.9089 17.6418 35.088 17.0923 35.6375C16.5428 36.187 16.3637 36.9226 16.3637 37.6362H18.5455C18.5455 37.4511 18.5691 37.3336 18.5917 37.2653C18.6128 37.2022 18.632 37.1833 18.6351 37.1803C18.6381 37.1772 18.657 37.158 18.72 37.137C18.7883 37.1143 18.9058 37.0907 19.0909 37.0907V34.9089ZM33.2728 4.36346C34.1593 4.36346 34.9091 5.11002 34.9091 5.87666H37.0909C37.0909 3.76687 35.2213 2.18164 33.2728 2.18164V4.36346ZM4.90912 2.18164C2.96049 2.18164 1.09094 3.76687 1.09094 5.87666H3.27276C3.27276 5.11002 4.0225 4.36346 4.90912 4.36346V2.18164ZM16.3637 37.6362C16.3637 39.496 15.6563 40.9715 14.5308 41.9912C13.3949 43.0203 11.7736 43.6362 9.88238 43.6362V45.818C12.2441 45.818 14.4089 45.0457 15.9957 43.608C17.5931 42.1609 18.5455 40.091 18.5455 37.6362H16.3637ZM9.88238 43.6362C6.24676 43.6362 3.27276 40.6417 3.27276 36.9148H1.09094C1.09094 41.817 5.01224 45.818 9.88238 45.818V43.6362ZM44.7273 36.9148C44.7273 40.6539 41.8057 43.6362 38.1819 43.6362V45.818C43.0638 45.818 46.9091 41.805 46.9091 36.9148H44.7273ZM38.1819 43.6362H9.88238V45.818H38.1819V43.6362ZM44.7273 34.9089H36V37.0907H44.7273V34.9089ZM46.9091 36.9148C46.9091 36.3689 46.7572 35.7403 46.1954 35.3166C45.7113 34.9516 45.1267 34.9089 44.7273 34.9089V37.0907C44.8606 37.0907 44.9325 37.1005 44.964 37.1074C44.9929 37.1138 44.9489 37.1093 44.8818 37.0587C44.8475 37.0329 44.8146 37.0004 44.7863 36.9627C44.7584 36.9253 44.7415 36.8913 44.732 36.867C44.7147 36.8228 44.7273 36.8255 44.7273 36.9148H46.9091ZM34.9091 5.87666V35.9998H37.0909V5.87666H34.9091ZM8.72731 13.0907H29.4546V10.9089H8.72731V13.0907ZM8.72731 20.7271H29.4546V18.5453H8.72731V20.7271ZM8.72731 28.3635H29.4546V26.1816H8.72731V28.3635ZM36 34.9089H19.0909V37.0907H36V34.9089Z"></path>
    </svg>
    <div class="aoformcheckdata__body">
      <div>Проверьте ваши данные в договоре</div>
<!--      <button class="aoformcheckdata__watch" @click="$store.commit('watchSample')">Смотреть образец</button>-->
      <button :disabled="$store.state.loading" class="aoformcheckdata__watch" @click="openUrl()">Смотреть образец</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openUrl(){
      window.open(
              this.$store.state.sampleUrl
              // "Скачать полис для проверки",
              //"left=100,top=100,width=320,height=320"
      );
    }
  }
}
</script>
<style lang="sass">
.aoformcheckdata
  padding: 32px
  background: colors.$lightgray
  display: flex
  align-items: center
  font-weight: 300
  font-size: 14px
  line-height: 24px
  margin-bottom: 32px
  &__icon
    display: block
    min-width: 48px
    width: 48px
    height: 48px
    fill: colors.$font
    margin-right: 18px
  &__body
    width: 100%
    display: flex
    flex-direction: column
    justify-content: space-between
    align-self: stretch
  &__watch
    width: fit-content
    position: relative
    cursor: pointer
    background: none
    border: none
    border-bottom: 1px dashed colors.$red
    padding: 0
    &:not(:focus-visible)
      outline: none
    &::before
      content: ''
      display: block
      position: absolute
      left: -10px
      right: -10px
      top: -10px
      bottom: -10px
</style>